import React, { useState, useCallback } from "react";
import { Box, Button } from "@mui/material";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditRangesDetail from "./EditRangesDetail";

const headerSpanSx = {
  display: "inline-block",
  flex: 1,
  minWidth: 0,
  alignSelf: "center",
  textAlign: "center",
  letterSpacing: "1px",
  fontSize: "18px",
};

const getAlarmDeactivatedState = (alarm) => {
  if (typeof alarm?.deactivated === "boolean") {
    return alarm.deactivated;
  }
  return false;
};

const EditAlarmLimitsRow = ({ alarm, isDeactivated: isDeactivatedOverride, onToggleAlarmState, config, saveAlarmRanges, serviceModeActive, solutionType, onChangeHandler, saveForm, restoreValuesAndUpdateForm }) => {

  const [isExpanded, setIsExpanded] = useState(false);
  const isDeactivated = typeof isDeactivatedOverride === "boolean" ? isDeactivatedOverride : getAlarmDeactivatedState(alarm);
  const toggleExpand = useCallback(() => { setIsExpanded((prev) => !prev) }, []);
  let lowWarningText = "";
  let highWarningText = "";
  let lowAlarmText = "";
  let highAlarmText = "";
  if ((alarm.lowWarning !== undefined) && (alarm.lowWarning !== null)) { lowWarningText = alarm.lowWarning };
  if ((alarm.highWarning !== undefined) && (alarm.highWarning !== null)) { highWarningText = alarm.highWarning };
  if ((alarm.lowAlarm !== undefined) && (alarm.lowAlarm !== null)) { lowAlarmText = alarm.lowAlarm };
  if ((alarm.highAlarm !== undefined) && (alarm.highAlarm !== null)) { highAlarmText = alarm.highAlarm }

  let warningRange = `${lowWarningText} ... ${highWarningText}`;
  let alarmRange = `${lowAlarmText} ... ${highAlarmText}`;

  return (
    <Box
      sx={{
        bgcolor: isDeactivated ? "rgba(128, 128, 128, 0.18)" : "background.light",
        borderRadius: 1,
        mb: 0.25,
        py: 0.5,
        opacity: isDeactivated ? 0.85 : 1,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "stretch" }}>
        <Box
          component="span"
          sx={{
            ...headerSpanSx,
            textAlign: "left",
            pl: "30px",
            pr: "12px",
            color: isDeactivated ? "text.disabled" : "text.primary",
            display: "grid",
            gridTemplateColumns: "minmax(0, 1fr) 120px",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box
            component="span"
            sx={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {alarm.hwId} / {alarm.valueName}
          </Box>

          <Box component="span" sx={{ display: "flex", justifyContent: "flex-start" }}>
            {serviceModeActive ? (
              <Button
                variant="outlined"
                size="small"
                onClick={() => onToggleAlarmState?.(alarm, isDeactivated)}
                sx={{
                  width: "100%",
                  minWidth: 0,
                  px: 1,
                  py: 0.2,
                  borderRadius: "10px",
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.6px",
                  lineHeight: 1.4,
                  textTransform: "uppercase",
                  color: isDeactivated ? "text.disabled" : "secondary.main",
                  borderColor: isDeactivated ? "text.disabled" : "secondary.main",
                  bgcolor: isDeactivated ? "rgba(255, 255, 255, 0.04)" : "transparent",
                  "&:hover": {
                    borderColor: isDeactivated ? "text.primary" : "secondary.light",
                    bgcolor: isDeactivated ? "rgba(255, 255, 255, 0.08)" : "rgba(255, 255, 255, 0.04)",
                  },
                }}
              >
                {isDeactivated ? "Deactivated" : "Active"}
              </Button>
            ) : (
              isDeactivated && (
                <Box
                  component="span"
                  sx={{
                    display: "inline-flex",
                    width: "100%",
                    justifyContent: "center",
                    px: 1,
                    py: 0.2,
                    borderRadius: "10px",
                    fontSize: "11px",
                    fontWeight: 700,
                    letterSpacing: "0.6px",
                    lineHeight: 1.4,
                    color: "text.disabled",
                    border: "1px solid",
                    borderColor: "text.disabled",
                    textTransform: "uppercase",
                  }}
                >
                  Deactivated
                </Box>
              )
            )}
          </Box>
        </Box>
        <Box component="span" sx={{ ...headerSpanSx, color: isDeactivated ? "text.disabled" : "warning.main" }}>{warningRange}</Box>
        <Box component="span" sx={{ ...headerSpanSx, color: isDeactivated ? "text.disabled" : "error.main" }}>{alarmRange}</Box>
        <Box component="span" sx={headerSpanSx}>
          {(serviceModeActive || solutionType === "lora") &&
            <Button
              variant={isDeactivated ? "outlined" : "text"}
              size="small"
              onClick={toggleExpand}
              sx={{
                color: isExpanded ? "secondary.main" : "white",
                minWidth: 42,
                mr: 0.5,
                textTransform: "none",
                borderColor: isDeactivated ? "rgba(255, 255, 255, 0.35)" : "transparent",
                bgcolor: isDeactivated ? "rgba(255, 255, 255, 0.06)" : "transparent",
                "&:hover": {
                  borderColor: isDeactivated ? "secondary.main" : "transparent",
                  bgcolor: isDeactivated ? "rgba(255, 255, 255, 0.12)" : "transparent",
                },
              }}
              endIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            >
              Edit
            </Button>
          }
        </Box>
      </Box>
      {
        (serviceModeActive || solutionType === "lora") &&
        <Box sx={{ display: isExpanded ? "block" : "none" }}>
          <EditRangesDetail
            alarm={alarm}
            isDeactivated={isDeactivated}
            config={config}
            saveAlarmRanges={saveAlarmRanges}
            onChangeHandler={onChangeHandler}
            saveForm={saveForm}
            restoreValuesAndUpdateForm={restoreValuesAndUpdateForm}
            solutionType={solutionType}
          />
        </Box>
      }
    </Box>
  );
};

export default EditAlarmLimitsRow;